import {Page} from "../../flair/Page.es6";

Page.match("/pay/card/").go(function() {
	const stripeKey = document.getElementById("stripejs").getAttribute("key");
	const stripeOptions = {
		apiVersion: "2023-08-16",
	};
	const stripe = Stripe(stripeKey, stripeOptions);
	const paymentElement = document.getElementById("payment-element");

	document.querySelector("button").disabled = true;

	const exampleInput = document.getElementById("example-input");
	let currentStyle = window.getComputedStyle(exampleInput);
	let clientSecret = paymentElement.dataset.pi;

	const appearance = {
		theme: "none",

		rules: {
			".Input": {
				backgroundColor: currentStyle.backgroundColor,
				border: currentStyle.border,
				borderRadius: currentStyle.borderRadius,
			},
			".Input:hover": {
				backgroundColor: "rgba(57, 170, 54, 0.05)",
			},
			".Input:focus": {
				borderColor: "#ff9b00",
				outline: "2px solid #ff9b00",
			},
		}
	};
	exampleInput.hidden = true;

	const elements = stripe.elements({clientSecret: clientSecret, appearance});
	const params = new URLSearchParams(window.location.search);

	const elementsOptions = {
		defaultValues: {
			billingDetails: {
				address: {
					country: params.get("country"),
					postal_code: params.get("postal_code"),
				}
			}
		}
	};

	const stripeElements = elements.create("payment", elementsOptions);
	stripeElements.mount(paymentElement);
	stripeElements.on("change", function(event) {
		// disable pay if no card details
		const btn = document.querySelector("button");
		if(event.value.type === "card") {
			btn.disabled = event.empty;
		}
		else {
			btn.disabled = false;
		}
	});
	stripeElements.on("focus", clearError);
	stripeElements.on("blur", clearError);
	stripeElements.on("ready", completeLoading);
	stripeElements.on("loaderror", completeLoading);

	function clearError() {
		errorElement.textContent = "";
	}

	function completeLoading() {
		form.classList.remove("loading");
	}

	const form = document.getElementById("payment-form");
	const errorElement = document.getElementById("card-error");

	form.addEventListener("submit", async function(event) {
		event.preventDefault();
		form.classList.add("loading");

		const {error: submitError} = await elements.submit();
		if (submitError) {
			errorElement.textContent = submitError.message;
			form.classList.remove("loading");
			return;
		}

		let returnUrl = new URL(location);
		returnUrl.pathname = "/pay/complete/";
		let currentUrlParams = new URLSearchParams(location.search);

		returnUrl.search = currentUrlParams.toString();

		const {error} = await stripe.confirmPayment({
			elements,
			paymentIntentSecret: clientSecret,
			confirmParams: {
				return_url: returnUrl.toString(),
			}
		}).then(function(result) {
			form.classList.remove("loading");

			if(result.error) {
				errorElement.textContent = result.error.message;
			}
		});
	});
});
